import * as React from 'react';
export const IcPatient = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 10.98c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5zm10.24-6.99h-3.48a.76.76 0 00-.76.76v4.74c0 1.02.62 1.9 1.5 2.29v1.41c0 .34.21.62.5.74v5.06h-2v-1c0-3.31-2.69-6-6-6s-6 2.69-6 6v2h14.5c.28 0 .5-.22.5-.5v-5.56c.29-.12.5-.41.5-.74v-1.41c.88-.39 1.5-1.26 1.5-2.29V4.75a.76.76 0 00-.76-.76zM19 6.79a.2.2 0 01-.2.2H18v.8a.2.2 0 01-.2.2h-.6a.2.2 0 01-.2-.2v-.8h-.8a.2.2 0 01-.2-.2v-.6c0-.11.09-.2.2-.2h.8v-.8c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2v.8h.8c.11 0 .2.09.2.2v.6z'
      fill='currentColor'
    />
  </svg>
);
